<template>
<section class="alternators p-4">
    <div class="max-w-4xl mx-auto">
        <div v-for="(section, i) in sections" class="alternator-section grid mb-12" :class="i % 2 ? 'even' : 'odd'">
            <SmoothLoader class="no-box p-8 vt:p-12">
                <h2 v-if="section.out_headline" v-html="section.out_headline" class="uppercase text-3xl vt:text-5xl text-primary-700 leading-none mb-4"></h2>
                <p v-if="section.out_blurb" v-html="section.out_blurb" class="font-bold text-primary-600 text-lg"></p>
            </SmoothLoader>
            <SmoothLoader class="box">
                <div>
                    <div class="prose text-primary-600" v-html="section.content"></div>
                </div>
            </SmoothLoader>
        </div>
    </div>
</section>
</template>

<script>
import { ref, computed, nextTick, watch } from 'vue';

export default {

    props: ['data'],

    setup(props) {
        return {
            ...props.data
        }
    }

}
</script>